import { render, staticRenderFns } from "./BlockType19Grid.vue?vue&type=template&id=7179ea32&scoped=true"
import script from "./BlockType19Grid.vue?vue&type=script&lang=ts"
export * from "./BlockType19Grid.vue?vue&type=script&lang=ts"
import style0 from "./BlockType19Grid.vue?vue&type=style&index=0&id=7179ea32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7179ea32",
  null
  
)

export default component.exports